import { createGlobalStyle } from 'styled-components';

export const GlobalStyles = createGlobalStyle`
  * {
    margin: 0;
    padding: 0;
    box-sizing: border-box;
  }

  html {
    font-size: 16px;
    scroll-behavior: smooth;
    height: 100%;
    width: 100%;
  }

  body {
    font-family: 'Inter', -apple-system, BlinkMacSystemFont, 'Segoe UI', 
      'Oxygen', 'Ubuntu', 'Cantarell', 'Fira Sans', 'Droid Sans', 'Helvetica Neue',
      sans-serif;
    -webkit-font-smoothing: antialiased;
    -moz-osx-font-smoothing: grayscale;
    background: transparent;
    color: #ffffff;
    overflow-x: hidden;
    height: 100%;
    width: 100%;
    /* Mobile scrolling improvements */
    -webkit-overflow-scrolling: touch;
    touch-action: pan-y;
  }

  #root {
    min-height: 100vh;
    min-height: 100dvh; /* Dynamic viewport height for mobile */
    width: 100%;
    display: flex;
    align-items: stretch;
    justify-content: stretch;
  }

  /* Mobile-specific improvements */
  @media (max-width: 767px) {
    body {
      position: relative;
    }
    
    /* Prevent iOS address bar issues */
    html {
      height: 100%;
      height: -webkit-fill-available;
    }
    
    #root {
      min-height: 100vh;
      min-height: 100dvh;
      min-height: -webkit-fill-available;
      align-items: stretch;
      justify-content: stretch;
    }
  }

  /* Custom scrollbar */
  ::-webkit-scrollbar {
    width: 6px;
  }

  ::-webkit-scrollbar-track {
    background: rgba(255, 255, 255, 0.1);
    border-radius: 3px;
  }

  ::-webkit-scrollbar-thumb {
    background: #3B82F6;
    border-radius: 3px;
  }

  ::-webkit-scrollbar-thumb:hover {
    background: #10B981;
  }

  /* Focus styles for accessibility */
  *:focus {
    outline: 2px solid #00FF85;
    outline-offset: 2px;
  }

  /* Remove focus outline for mouse users */
  *:focus:not(:focus-visible) {
    outline: none;
  }

  /* Date input styling */
  input[type="date"]::-webkit-calendar-picker-indicator {
    filter: invert(1);
    opacity: 1;
    color: #ffffff;
    cursor: pointer;
    transition: all 0.2s ease;
  }

  input[type="date"]::-webkit-calendar-picker-indicator:hover {
    transform: scale(1.1);
  }

  /* Number input styling */
  input[type="number"]::-webkit-outer-spin-button,
  input[type="number"]::-webkit-inner-spin-button {
    -webkit-appearance: none;
    margin: 0;
  }

  input[type="number"] {
    -moz-appearance: textfield;
  }

  /* Selection styling */
  ::selection {
    background: rgba(0, 255, 133, 0.3);
    color: #ffffff;
  }

  ::-moz-selection {
    background: rgba(0, 255, 133, 0.3);
    color: #ffffff;
  }
  /* Custom Cursor - Replaces the standard pointer "finger" */
  button, a, [role="button"], input[type="submit"], input[type="button"], input[type="reset"], label, select {
    cursor: url('data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSIyNCIgaGVpZ2h0PSIyNCIgdmlld0JveD0iMCAwIDI0IDI0Ij48Y2lyY2xlIGN4PSIxMiIgY3k9IjEyIiByPSI2IiBmaWxsPSIjM0I4MkY2Ii8+PC9zdmc+') 12 12, pointer !important;
  }
`;
